import { GridHeader } from './../../tracking-overview/interfaces/grid';

export const protocolColumn: GridHeader = {
    displayText: 'Protocol Code',
    key: 'protocolCode',
    sort: 'asc',
    enableFilter: true,
    enableSearch: true
};

export const regionColumn: GridHeader = {
    displayText: 'Region',
    key: 'region',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const projectNumberColumn: GridHeader = {
    displayText: 'Project №',
    key: 'projectNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const investigatorNumberColumn: GridHeader = {
    displayText: 'Investigator Number',
    key: 'investigatorNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true

};

export const investigatorNameColumn: GridHeader = {
    displayText: 'Investigator Name',
    key: 'investigatorName',
    sort: null,
    enableFilter: true,
    enableSearch: true

};

export const countryColumn: GridHeader = {
    displayText: 'Country',
    key: 'countryName',
    sort: null,
    enableFilter: true,
    enableSearch: true

};

export const screeningNumberColumn: GridHeader = {
    displayText: 'Screening №',
    key: 'screeningNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const patientNumberColumn: GridHeader = {
    displayText: 'Patient №',
    key: 'patientNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true

};

export const collectionDateColumn: GridHeader = {
    displayText: 'Collection Date',
    key: 'specimenCollectionDate',
    sort: null,
    enableFilter: true,
    skipConversion: true,
    enableSearch: true,
    isDate: true
};

export const collectionTimeColumn: GridHeader = {
    displayText: 'Collection Time',
    key: 'specimenCollectionTime',
    sort: null,
    enableFilter: true,
    skipConversion: true,
    enableSearch: true,
    isTime: true
};

export const visitNameColumn: GridHeader = {
    displayText: 'Visit Name/ PVC',
    key: 'protocolVisitDescription',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const accessionNumberColumn: GridHeader = {
    displayText: 'Accession',
    key: 'accessionNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isLink: true
};

export const containerNumberColumn: GridHeader = {
    displayText: 'Container №',
    key: 'containerNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const containerBarcodeColumn: GridHeader = {
    displayText: 'Container Barcode №',
    key: 'barcode',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isLink: true
};

export const sampleStatusColumn: GridHeader = {
    displayText: 'Sample Status',
    key: 'sampleStatus',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const kitReceiptDateColumn: GridHeader = {
    displayText: 'Kit Receipt Date',
    key: 'kitReceivedDate',
    sort: null,
    skipConversion: true,
    enableFilter: true,
    enableSearch: true,
    isDate: true
};

export const kitReceiptTimeColumn: GridHeader = {
    displayText: 'Kit Receipt Time',
    key: 'kitReceivedTime',
    sort: null,
    skipConversion: true,
    enableFilter: true,
    enableSearch: true,
    isTime: true
};

export const containerReceiptDateColumn: GridHeader = {
    displayText: 'Container Receipt Date',
    key: 'containerReceivedDate',
    sort: null,
    enableFilter: true,
    skipConversion: true,
    enableSearch: true,
    isDate: true,
};

export const containerReceiptTimeColumn: GridHeader = {
    displayText: 'Container Receipt Time',
    key: 'containerReceivedTime',
    sort: null,
    skipConversion: true,
    enableFilter: true,
    enableSearch: true,
    isTime: true,
};

export const expectedReceiptConditionColumn: GridHeader = {
    displayText: 'Expected Receipt Condition',
    key: 'expectedReceiptCondition',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const actualReceiptConditionColumn: GridHeader = {
    displayText: 'Actual Receipt Condition',
    key: 'actualReceiptCondition',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const cancellationDescriptionColumn: GridHeader = {
    displayText: 'Cancellation Description',
    key: 'cancelDescription',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const containerLabelLine1Column: GridHeader = {
    displayText: 'Container Label Line 1',
    key: 'containerLabel1',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const containerLabelLine2Column: GridHeader = {
    displayText: 'Container Label Line 2',
    key: 'containerLabel2',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const siteShipmentStatus: GridHeader = {
    displayText: 'Site Shipment Status',
    key: 'shipmentStatus',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isLink: true,
    defaultValue : 'N/A'
};
export const expectedReturnStateColumn: GridHeader = {
    displayText: 'Expected Return State',
    key: 'expectedReturnState',
    sort: null,
    enableFilter: true,
    enableSearch: true
};
export const daysPendingReceiptColumn: GridHeader = {
    displayText: 'Number of days Pending Receipt',
    key: 'daysPendingReceipt',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const notificationSentDate1Column: GridHeader = {
    displayText: 'Notification 1 Sent Date',
    key: 'notification1Sent',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isDate: true
};

export const notificationSentDate1TimeColumn: GridHeader = {
    displayText: 'Notification 1 Sent Time',
    key: 'notification1SentTime',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isTime: true
};

export const notificationSentTo1Column: GridHeader = {
    displayText: 'Notification 1 Sent To',
    key: 'notification1SentTo',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const notificationSentDate2Column: GridHeader = {
    displayText: 'Notification 2 Sent Date',
    key: 'notification2Sent',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isDate: true
};

export const notificationSentDate2TimeColumn: GridHeader = {
    displayText: 'Notification 2 Sent Time',
    key: 'notification2SentTime',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isTime: true
};

export const notificationSentTo2Column: GridHeader = {
    displayText: 'Notification 2 Sent To',
    key: 'notification2SentTo',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const notificationSentDate3Column: GridHeader = {
    displayText: 'Notification 3 Sent Date',
    key: 'notification3Sent',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isDate: true
};

export const notificationSentDate3TimeColumn: GridHeader = {
    displayText: 'Notification 3 Sent Time',
    key: 'notification3SentTime',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isTime: true
};

export const notificationSentTo3Column: GridHeader = {
    displayText: 'Notification 3 Sent To',
    key: 'notification3SentTo',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const visitDescriptionColumn: GridHeader = {
    displayText: 'Visit Description',
    key: 'protocolVisitDescription',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const protocolVisitCodeColumn: GridHeader = {
    displayText: 'Protocol Visit Code',
    key: 'protocolVisitCode',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const samplesRegisteredDateColumn: GridHeader = {
    displayText: 'Sample Registered Date',
    key: 'sampleRegisteredDate',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isDate: true
};


export const samplesRegisteredTimeColumn: GridHeader = {
    displayText: 'Sample Registered Time',
    key: 'sampleRegisteredTime',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isTime: true
};

export const shippedFromLocationColumn: GridHeader = {
    displayText: 'Shipped from Location',
    key: 'shippedFromLocation',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const shippedToLocationOrgColumn: GridHeader = {
    displayText: 'Shipped to Location Org.',
    key: 'shippedToLocation',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const shippedDateColumn: GridHeader = {
    displayText: 'Shipped Date',
    key: 'shippedDate',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isDate: true
};

export const shippedTimeColumn: GridHeader = {
    displayText: 'Shipped Time',
    key: 'shippedTime',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isTime: true
};

export const airwayBillNumberColumn: GridHeader = {
    displayText: 'Airbill №',
    key: 'airwayBillNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const specimenClassDescriptionColumn: GridHeader = {
    displayText: 'SMART Specimen Class Description',
    key: 'specimenClassDescription',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const specimenClassColumn: GridHeader = {
    displayText: 'SMART Specimen Class',
    key: 'specimenClass',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const sampleLocationColumn: GridHeader = {
    displayText: 'SMART Sample Location',
    key: 'sampleLocation',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const shipmentCreatedDate: GridHeader = {
    displayText: 'Shipment Created Date',
    key: 'shipmentCreatedDate',
    sort: null,
    skipConversion: true,
    enableFilter: true,
    enableSearch: true,
    isDate: true
};

export const shipmentCreatedTime: GridHeader = {
    displayText: 'Shipment Created Time',
    key: 'shipmentCreatedTime',
    skipConversion: true,
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isTime: true
};

export const shipmentSubmittedDate: GridHeader = {
    displayText: 'Shipment Submitted Date',
    key: 'shipmentSubmittedDate',
    sort: null,
    enableFilter: true,
    skipConversion: true,
    enableSearch: true,
    isDate: true
};

export const shipmentSubmittedTime: GridHeader = {
    displayText: 'Shipment Submitted Time',
    key: 'shipmentSubmittedTime',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    skipConversion: true,
    isTime: true
};

export const scheduledShipmentDate: GridHeader = {
    displayText: 'Scheduled Site Shipment Date',
    key: 'scheduledShipmentDate',
    sort: null,
    enableFilter: true,
    skipConversion: true,
    enableSearch: true,
    isDate: true
};


export const scheduledShipmentTime: GridHeader = {
    displayText: 'Scheduled Site Shipment Time',
    key: 'scheduledShipmentTime',
    sort: null,
    enableFilter: true,
    skipConversion: true,
    enableSearch: true,
    isTime: true
};

export const shipmentCourier: GridHeader = {
    displayText: 'Courier',
    key: 'shipmentCourier',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const shippedToOrganizationName: GridHeader = {
    displayText: 'Shipped To Organization Name',
    key: 'shippedToOrganizationName',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const siteAirbillNumberColumn: GridHeader = {
    displayText: 'Site Waybill Number',
    key: 'airwayBillNumber',
    sort: null,
    enableFilter: true,
    enableSearch: true
};
